import React from 'react';
import { TEAM_EMAIL } from '@/shared/utils/contact';

/** The team's address as a mailto link, with the address visible. */
export function TeamEmailLink() {
    return <a href={`mailto:${TEAM_EMAIL}`}>{TEAM_EMAIL}</a>;
}

/**
 * Renders a message string, turning the team address inside it into a
 * mailto link. Text without the address renders unchanged.
 */
export function withTeamEmailLink(text) {
    const parts = String(text).split(TEAM_EMAIL);
    if (parts.length === 1) {
        return text;
    }
    return parts.flatMap((part, index) =>
        index === 0 ? [part] : [<TeamEmailLink key={`email-${index}`} />, part]
    );
}

export default TeamEmailLink;
